






















































import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import CheckIcon from '@/components/icons/Check.vue';
import CircleArrow from '@/componentsV2/atoms/CircleArrow/CircleArrow.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

export type RadioGroupWithCustomVariant = 'sm' | 'md';

export interface IOption<T = string> {
  slug: string;
  value: T;
  label: string;
  requiredCustomValue?: boolean;
}

@Component<RadioGroupWithCustom>({
  components: {
    Input,
    CheckIcon,
    CircleArrow,
    Typography
  }
})
export default class RadioGroupWithCustom extends Vue {
  @Model('input') value!: any;

  @Prop(String) label!: string;
  @Prop() description?: string;
  @Prop({ default: '60px' }) collapsedHeight?: string;
  @Prop({ default: '' }) selected?: string;
  @Prop({ default: false }) requiredCustomValue?: string;
  @Prop(String) name!: string;
  @Prop({ default: false }) hasError?: boolean;
  @Prop({ default: '' }) helpText?: string;
  @Prop({ default: 'md' }) variant?: RadioGroupWithCustomVariant;
  @Prop(String) inputLabel?: string;
  @Prop(String) inputPlaceholder?: string;
  @Prop({ default: 'numeric' }) inputMode?: string;

  get isMarcked() {
    return this.selected === this.name;
  }

  onKeypress(evt: KeyboardEvent) {
    const keysAllowed = Array.from(Array(10).keys()).map(String);
    const keyPressed = evt.key;

    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault();
    }
  }

  toggle() {
    this.$emit('toggle', this.name);
  }
}
